import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { Page } from '@app/core/models/page';
import { Configuration } from '../configuration';
import { JourneyPortal } from '@app/core/models/journey/journey-portal';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class JourneyService {
  private baseUrl: string;
  private configuration = new Configuration();

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.passenger.api.mobilityEngine;
  }

  public getJourneys(tokens: string[] = [], tapTypes: string[] = [], fromStartDate?: Date, toStartDate?: Date,
      page: number = 0, size : number = 30, sortElement: string = 'startDate', sortOrder: 'ASC' | 'DESC' = 'DESC'): Observable<Page<JourneyPortal>> {

    if (tokens.length === 0) {
      return of({ content: [] });
    }

    let params = new HttpParams()
      .set('sort', sortElement + ',' + sortOrder)
      .set('page', page.toString())
      .set('size', size.toString());

    if (environment.passenger.journeys.startTime && environment.passenger.journeys.endTime) {
      params = params
        .set('startTime', environment.passenger.journeys.startTime)
        .set('endTime', environment.passenger.journeys.endTime);
    }

    if (fromStartDate) {
      params = params.set('fromStartDate', moment(fromStartDate).startOf('day').format('yyyy-MM-DD'));
    }
    if (toStartDate) {
      params = params.set('toStartDate', moment(toStartDate).endOf('day').format('yyyy-MM-DD'));
    }

    if (tokens && tokens.length > 0) {
      tokens.forEach((element) => {
        params = params.append('accessMediaIdentificationTokens', element);
      });
    }

    const withCredentials = this.configuration.withCredentials;

    tapTypes.forEach(type => {
      params = params.append('tapTypes', type);
    });
    params = params.set('withLocalization', <any>true);
    params = params.set('withLocationInfo', <any>true);
    params = params.set('withRefund', <any>true);

    return this.httpClient.get<Page<JourneyPortal>>(this.baseUrl + '/v1/journeys', { params, withCredentials });
  }

}
